
define('text!modules/reporting/templates/tabs.html',[],function () { return '<div class="reporting-main-tabs"></div>\n';});

